import * as React from "react";
import { Chip, styled, Theme } from "@mui/material";
import { CHAT_ELEMENT_HEIGHT } from "../consts/sizeConsts";
import { PatientColorMap } from "../../layout/patientColorMap";
import { QuestionDescription } from "./questionDescription";
import { QualifierValue } from "fe-common/graphql";

//region [[ Styles ]]

const RefinementChipView = styled("div")({
  display: "flex",
  flexFlow: "row",
  flexWrap: "wrap",
  marginBottom: "15px",
  alignItems: "center",
  "&:last-child": {
    marginBottom: "0px",
  },
});

const ChipView = styled(Chip)(
  ({
    theme,
    selectedvalue,
  }: {
    theme?: Theme;
    selectedvalue: "true" | "false";
  }) => ({
    maxWidth: "fit-content",
    fontWeight: 500,
    fontSize: "15px",
    height: CHAT_ELEMENT_HEIGHT,
    borderRadius: "60px",
    padding: "10px",
    color: selectedvalue === "true" ? "white" : PatientColorMap.Default,
    "& span.patient-MuiChip-label": {
      color: selectedvalue === "true" ? "white" : PatientColorMap.Default,
    },
    backgroundColor:
      selectedvalue === "true"
        ? PatientColorMap.Selected
        : PatientColorMap.Unselected,
    "&:focus, &:hover, &:active": {
      color: selectedvalue === "true" ? "white" : PatientColorMap.Default,
      backgroundColor:
        selectedvalue === "true"
          ? PatientColorMap.Selected
          : PatientColorMap.Unselected,
    },
  }),
);

//endregion [[ Styles ]]

//region [[ Props ]]

export interface RefinementChipProps {
  disabled: boolean;
  label: string;
  selected: boolean;
  onClick: () => void;
  qualifierValue: QualifierValue;
  questionText: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const RefinementChip = ({
  qualifierValue,
  ...props
}: RefinementChipProps) => {
  // Make a fake qualified feature
  return (
    <RefinementChipView>
      <ChipView
        disabled={props.disabled}
        label={props.label}
        selectedvalue={props.selected ? "true" : "false"}
        onClick={props.onClick}
      />
      <QuestionDescription
        qualifiedFeature={qualifierValue}
        questionText={props.questionText}
        featureId={qualifierValue?.id}
      />
    </RefinementChipView>
  );
};
